import { swSignals } from 'serviceWorker/events/swSignals';
import { debounceNext } from 'serviceWorker/helpers/debounce';

/**
 * The app language changed: data in the old language is downloaded again
 * (debounced). Running operations are aborted first, then the data clearer
 * flushes the project data.
 */
const change = debounceNext((): void => {
  swSignals.projectDataReplaced.emit();
  swSignals.languageChanged.emit();
}, 1000);

export default { change };
